import QuoteProposalSidebar from "./QuoteProposalSidebar";
import QuoteProposalHeader from "./QuoteProposalHeader";
import QuoteStepper from "./QuoteStepper";

export default function ProposalLandingPage() {
  
  return (
    <div className="d-flex">
      <QuoteProposalSidebar pagename="proposal-landingpage" />
      <div className="flex-grow-1 d-flex flex-column overflow-hidden">
        <QuoteProposalHeader />
        <main className="flex-grow-1 overflow-auto p-4 bg-light quote-proposal-main-content">
          <div className="mb-4">
            <h2 className="fs-4 fw-bold">New Insurance Quote Proposal</h2>
            <span>Create a new insurance quote for your client</span>
          </div>

          <div className="row g-4 ">
            <div className="col-12">
              <QuoteStepper />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
